import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

interface HeaderContainerProps extends BoxProps {
  sticky?: boolean;
  children?: React.ReactNode;
}

// eslint-disable-next-line react/display-name
export const HeaderContainer = React.forwardRef<
  HTMLDivElement,
  HeaderContainerProps
>(({ sticky = true, children, ...rest }, ref) => (
  <Box
    as="header"
    position={sticky === false ? 'absolute' : 'fixed'}
    zIndex={1100}
    width="100%"
    top={0}
    ref={ref}
    {...rest}
  >
    {children}
  </Box>
));

interface HeaderBackgroundProps extends Omit<BoxProps, 'shadow'> {
  scrolled: boolean;
  shadow: boolean;
  transparent?: boolean;
  bgColor?: string;
}

export const HeaderBackground: React.FC<HeaderBackgroundProps> = ({
  scrolled,
  shadow,
  transparent,
  bgColor,
  ...rest
}) => {
  // Determine background color
  let background: string | undefined;
  if (transparent === false && !scrolled) {
    background = bgColor ?? '#fff';
  } else if (bgColor) {
    background = bgColor;
  } else {
    background = transparent === true && !scrolled ? 'none' : '#fff';
  }

  // Determine box shadow
  const boxShadow =
    scrolled && shadow ? '0 3px 20px -2px rgba(0, 0, 0, 0.12)' : undefined;

  return (
    <Box
      width="100%"
      position="relative"
      bg={background}
      height={{ base: '64px', xl: '112px' }}
      boxShadow={boxShadow}
      {...rest}
    />
  );
};

export const HeaderBlock = (props: BoxProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      height="100%"
      gap="20px"
      {...props}
    />
  );
};

interface HeaderBlockMobileProps extends BoxProps {
  whiteBackground: boolean;
  children?: React.ReactNode;
}

export const HeaderBlockMobile: React.FC<HeaderBlockMobileProps> = ({
  whiteBackground,
  children,
  ...rest
}) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    position="relative"
    height="100%"
    zIndex={1400}
    bg={whiteBackground ? '#fff' : 'transparent'}
    {...rest}
  >
    {children}
  </Box>
);

export const DesktopContainer = (props: BoxProps) => (
  <Box
    width="100%"
    height="100%"
    px={{ base: '13px', md: '40px', xl: '64px' }}
    {...props}
  />
);

export const MobileContainer = (props: BoxProps) => {
  return <Box height="100%" padding="0 30px" {...props} />;
};

export const RightNavs = (props: BoxProps) => (
  <Box
    display="flex"
    alignItems="center"
    height="100%"
    justifyContent="flex-end"
    {...props}
  />
);
